/**
 * Shared literals for the public offering page.
 *
 * The section name lives here rather than inline because both offering mappers
 * emit it and the page uses it as a DOM id, matched by string equality. Three
 * copies of a string that has to agree is one rename away from a section the
 * sidebar cannot scroll to — and a fourth copy, written `'Services and
 * requests'`, is exactly how that bug got in once already.
 */

/**
 * The section holding an offering's request buttons.
 *
 * Doubles as the element id: the mappers use the section name as the anchor the
 * sidebar and `scrollTo` look for.
 */
export const SERVICES_SECTION = 'Services & Requests';
